import { Component, OnInit, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/api.service';
import { AppService } from '../../services/app.service';
import { FbService } from '../../services/fb.service';
import { GtagService } from '../../services/gtag.service';

declare var window:any;

@Component({
  selector: 'pagafacil-page',
  templateUrl: './pagafacil-page.component.html',
  styleUrls: ['./pagafacil-page.component.scss']  
})
export class PagafacilPage implements OnInit,AfterViewInit, OnDestroy {
  
  public isSendAnalytics  = false;
  public itensBreadcrumbs = [];
  public file             = null;
  public loader           = false;
  public loaderPagamento  = false;
  public data             = null;
  public servicos         = null;
  public content          = 1;
  public pagamentoData    = null;
  public onSendPagamento  = new EventEmitter();
  public email            = null;
  public pagafacilId      = null;
  public send_automatico  = false;
  
  constructor(
    private route: ActivatedRoute,
    private api: ApiService,
    private app: AppService,
    private gtag: GtagService,
    private fb: FbService 
  ){ 
    this.file = typeof(this.route.params["_value"].file) != "undefined" ? this.route.params["_value"].file : null;
    this.setItensBreadcrumbs();
  }
  /**
  * 
  * Seta os breadcrumbs
  * 
  **/
  setItensBreadcrumbs(){

    this.itensBreadcrumbs.push({
      text: "Pedido"
    });
    this.itensBreadcrumbs.push({
      text: "Paga Fácil"
    });
    this.itensBreadcrumbs.push({
      text: "File: "+this.file
    });

  }
  /**
   * 
   * Get data
   * 
   */
  getData(){

    try{

      this.loader = true;

      this.api.pagamento().dadosLinkPagamento(this.file).subscribe(response => {

        this.loader = false;

        if(response.status == 1){
          
          this.data = response.data;

          if(this.data.dados_reserva != null){

            this.servicos = typeof(this.data.dados_reserva.programacaoFile.Servico.length) == "undefined" ? [this.data.dados_reserva.programacaoFile.Servico] : this.data.dados_reserva.programacaoFile.Servico;

          }

        }  

      },(response) => {

        this.loader = false;
        
      });

    }catch(e){

    }

  }
  /**
   * 
   * Inicia o processo do pagamento
   * 
   */
  iniciarProcessoPagamento(item){

    item.file          = this.file;
    this.pagamentoData = item;
    this.content = 2;
    this.app.toSection("#page-content");

  }
  _requestEnd(response){
    this.loaderPagamento = false;
  }
  /**
   * 
   * On Sucesso Pagamento
   * 
   */
  onSuccessPagamento(data){

    this.email           = data.data.email; 
    this.pagafacilId     = data.data.id;
    this.send_automatico = true;
    this.content         = 3;

  }
  /**
   * 
   * Pagar
   * 
   */
  pagar(){

    this.loaderPagamento = true;
    this.onSendPagamento.emit();

  }
  updateResponse(response){

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit(){ 
    this.getData();
  }
  ngAfterViewInit(): void {
    
  }
  /**
   *
   * Send analytics
   *
   */
  sendAnalytics() {
    
    if(!this.isSendAnalytics) {
      
      this.isSendAnalytics = true;
      
      setTimeout(() => {
        this.gtag.sendPage();
        this.fb.init();
        this.fb.pageView();
      }, 100);
    
    }

  }
  /**
   * 
   * On Destroy
   * 
   */
  ngOnDestroy(): void {
    this.isSendAnalytics = false;
  }

}
